











































import { Component, Prop, Watch } from "vue-property-decorator";
import {
  HistoricoProduto,
  HistoricosProdutosService,
} from "@/services/historicos-produtos.service";
import Loading from "@/shared/components/loading.vue";
import { dateTime, moeda } from "@/shared/filters";
import Tooltip from "@/shared/components/tooltip.vue";
import DataTable from "@/shared/components/data-table.vue";
import Confirm from "@/shared/components/confirm.vue";
import ManterHistoricoProduto from "./ManterHistoricoProduto.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
@Component({
  components: { Loading, Tooltip, Confirm, ManterHistoricoProduto, DataTable },
  filters: { dateTime, moeda },
})
export default class HistoricosProdutos extends mixins(GlobalMixin) {
  @Prop() idProduto!: string;
  historicos: Promise<HistoricoProduto[]> | null = null;
  headers = [
    { value: "codigoFornecedor", text: "Codigo Fornecedor" },
    { value: "valorVenda", text: "Valor Venda" },
    { value: "validoDe", text: "Válido De" },
    { value: "validoAte", text: "Válido Até" },
    { value: "acoes", text: "Ações", sortable: false },
  ];
  mounted() {
    this.fetchHistoricos();
  }
  async fetchHistoricos() {
    this.historicos = HistoricosProdutosService.listarPorIdProduto(
      this.idProduto
    );
  }
  @Watch("idProduto")
  changeProduto() {
    this.fetchHistoricos();
  }
  async excluirHistorico(item: HistoricoProduto) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir histórico do produto `;
    const text = `Deseja realmente deletar o histórico com código de fornecedor ${item.codigoFornecedor} ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await HistoricosProdutosService.removerHistorico(
        item.idHistoricoProduto
      ).finally(this.stopLoader);
      this.fetchHistoricos();
    }
  }
  async adicionarHistorico() {
    const modal = this.$refs.manter as ManterHistoricoProduto;
    await modal.novoHistorico(this.idProduto);
    this.fetchHistoricos();
  }
  async editarHistorico(historicoProduto: HistoricoProduto) {
    const modal = this.$refs.manter as ManterHistoricoProduto;
    await modal.editarHistorico(historicoProduto.idHistoricoProduto);
    this.fetchHistoricos();
  }
}
